export const responsiveSpacing = { xs: 2, md: 2, lg: 3 };
